import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getIncidentContentDetails } from "../../redux/actionCreator";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { incidentContent } from "../../redux/commonReducer";

export default function Page1({ setStage, setInputs, inputs, pageAccess, inputErrors, setInputErrors }) {

  const { t } = useTranslation();
  const location = useLocation()
  const lang = localStorage.getItem('lang')
  const navigate = useNavigate()
  const details = useSelector(incidentContent)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getIncidentContentDetails())
  }, [])

  return (
    <div className="Page1">
      <section className="content container">
        <article>
          {
            details && <p dangerouslySetInnerHTML={{ __html: details['incident_intro_' + lang], }}></p>
          }
        </article>
      </section>
      {details?.['incident_intro_' + lang] &&
        <section className="form-fill-up container">
          <div className="d-flex flex-column">
            <label htmlFor="conditions">
              <input
                id="conditions"
                type="checkbox"
                checked={inputs.agree_conditions}
                onChange={(e) => (
                  setInputErrors(s => ({ ...s, agree_conditions: false })),
                  setInputs((s) => ({ ...s, agree_conditions: e.target.checked }))
                )}
              />
              <div>
                {t('i_have_read_and_agreed_to_all_the_information_mentioned_above')}
              </div>
            </label>
            <small id="agree_conditions" className="error">{inputErrors.agree_conditions && t('please_agree_to_continue')}</small>
          </div>
          <div className="button-div">
            <button
              className={"next-button" + (pageAccess[2] ? "" : " disabled")}
              onClick={() => navigate(`/${lang}/report_incident/personal_information`)}
              disabled={!inputs.agree_conditions}
            >
              {t('continue')}
              <img
                className="right"
                src="./assets/img/icons/Icon awesome-arrow-right.svg"
                alt=""
              />
            </button>
          </div>
        </section>
      }
    </div >
  );
}
